function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Outline_Old_Icons",
  "data-name": "Outline Old Icons"
}, React.createElement("path", {
  d: "M23.38,23h-.63V8.38A.38.38,0,0,0,22.38,8h-3a.38.38,0,0,0-.38.38V23H16.75V15.38a.38.38,0,0,0-.37-.38h-3a.38.38,0,0,0-.38.38V23H10.75V13.38a.38.38,0,0,0-.37-.38h-3a.38.38,0,0,0-.38.38V23H4.75V18.38A.38.38,0,0,0,4.38,18h-3a.38.38,0,0,0-.38.38V23H.38a.38.38,0,1,0,0,.75h23a.38.38,0,0,0,0-.75ZM1.75,23V18.75H4V23Zm6,0V13.75H10V23Zm6,0V15.75H16V23Zm6,0V8.75H22V23ZM2.88,12.75a1.38,1.38,0,0,0,1.37-1.37,1.31,1.31,0,0,0-.12-.56l4-3.31A1.37,1.37,0,0,0,10,7.15l3.5,1.16s0,0,0,.07a1.38,1.38,0,0,0,2.75,0A1.37,1.37,0,0,0,16,7.62l4.28-5a1.41,1.41,0,0,0,.58.13A1.38,1.38,0,1,0,19.5,1.38a1.36,1.36,0,0,0,.23.75l-4.28,5A1.4,1.4,0,0,0,14.88,7a1.38,1.38,0,0,0-1.14.6l-3.5-1.16s0,0,0-.06a1.38,1.38,0,1,0-2.75,0,1.3,1.3,0,0,0,.12.55l-4,3.31a1.37,1.37,0,1,0-.77,2.51Zm18-12a.63.63,0,1,1-.63.63A.63.63,0,0,1,20.88.75Zm-6,7a.63.63,0,1,1-.63.63.66.66,0,0,1,0-.15l0,0a.28.28,0,0,0,0-.09A.61.61,0,0,1,14.88,7.75Zm-6-2a.63.63,0,1,1-.63.63A.63.63,0,0,1,8.88,5.75Zm-6,5a.63.63,0,1,1-.63.63A.63.63,0,0,1,2.88,10.75Z"
})));

var SvgChart = function SvgChart(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 23.75 23.75",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chart.fbf9d36e.svg";
export { ForwardRef as ReactComponent };